import { useTranslation } from 'react-i18next';

import { Link } from '@tanstack/react-router';
import { SearchX } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] w-full flex-1 items-center justify-center p-4">
      <Card className="flex w-full max-w-lg flex-col items-center gap-6 px-8 py-12 text-center">
        <span className="flex size-16 items-center justify-center rounded-md bg-primary-light/25 [&_svg]:size-8 [&_svg]:text-primary-light">
          <SearchX aria-hidden="true" />
        </span>
        <div className="flex flex-col gap-2">
          <p className="text-3xl font-bold text-primary-light">404</p>
          <h1 className="text-2xl font-bold text-text-primary">{t('pageNotFound')}</h1>
          <p className="text-base text-text-secondary">{t('pageNotFoundDescription')}</p>
        </div>
        <Button asChild>
          <Link to="/estates">{t('goToEstates')}</Link>
        </Button>
      </Card>
    </div>
  );
};
